import React from "react";
import "../styles/Hero.css";
import heroImage from "../assets/images/section2.webp"; // apni background image ka path sahi rakhen

function Hero() {
  return (
    <section
      id="home"
      className="hero"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="overlay">
        <h1>ZARKHANI NEXUS SOLUTIONS</h1>
        <p>Where Fulfill The Demands Of Industrial Equipments</p>
      </div>
    </section>
  );
}

export default Hero;
